import { SHERLOCKS_URL } from "@utils/Constant";
import { getToken } from "@utils/helpers/api.helper";

class SherlockHelper {
  static buildOrderUrl = (officeId: string, amountInCents: number): string => {
    return `${SHERLOCKS_URL.REQUEST}?token=${getToken()}&officeId=${officeId}&amount=${amountInCents * 100}`;
  };
}

export default SherlockHelper;
